<template>
  <b-modal
    id="modalSobre"
    :ok-only="true"
    ok-variant="danger"
    ok-title="Fechar"
    size="lg"
    title="Sobre"
    ref="modal"
  >
    <img src="../../public/assets/img/sobre.jpeg" width="100%" />
  </b-modal>
</template>

<script>
export default {
  name: "ModalSobre",
  props: {
    visible: Boolean,
  },
  watch: {
    visible() {
      this.$bvModal.show("modalSobre");
    },
  },
  methods: {},
};
</script>

<style>

</style>